export const FETCH_PERFORMER_EARNINGS_START = 'FETCH_PERFORMER_EARNINGS_START'
export const FETCH_PERFORMER_EARNINGS_SUCCESS = 'FETCH_PERFORMER_EARNINGS_SUCCESS'
export const FETCH_PERFORMER_EARNINGS_FAILURE = 'FETCH_PERFORMER_EARNINGS_FAILURE'

export const FETCH_F2F_PENDING_CALLS_START = 'FETCH_F2F_PENDING_CALLS_START'
export const FETCH_F2F_PENDING_CALLS_SUCCESS = 'FETCH_F2F_PENDING_CALLS_SUCCESS'
export const FETCH_F2F_PENDING_CALLS_FAILURE = 'FETCH_F2F_PENDING_CALLS_FAILURE'

export const CREATE_PACKAGES="CREATE_PACKAGES"
export const FACE_2_FACE_CREATE_PACKAGE_SUCESS="FACE_2_FACE_CREATE_PACKAGE_SUCESS"
export const  FACE_2_FACE_CREATE_PACKAGE_FAILURE="FACE_2_FACE_CREATE_PACKAGE_FAILURE"

export const FACE_TO_FACE_PACKAGE_SUCCESS = "FACE_TO_FACE_PACKAGE_SUCCESS"
export const FACE_TO_FACE_PACKAGE_FAILURE = "FACE_TO_FACE_PACKAGE_FAILURE"
export const TOTAL_GET_F2F_PACKAGES ="TOTAL_GET_F2F_PACKAGES"

export const FACE_TO_FACE_PACKAGE_DISCOUNT = "FACE_TO_FACE_PACKAGE_DISCOUNT"
export const FACE_TO_FACE_PACKAGE_DISCOUNT_SUCCESS = "FACE_TO_FACE_PACKAGE_DISCOUNT_SUCCESS"
export const FACE_TO_FACE_PACKAGE_DISCOUNT_FAILURE = "FACE_TO_FACE_PACKAGE_DISCOUNT_FAILURE"

export const GET_SINGLE_SESSION ="GET_SINGLE_SESSION"
export const GET_SINGLE_SESSION_SUCCESS ="GET_SINGLE_SESSION_SUCCESS"
export const GET_SINGLE_SESSION_FAILURE ="GET_SINGLE_SESSION_FAILURE"

export const SHOW_FACE2FACE_PACKAGE_SELECTION = "START_FACE2FACE_PACKAGE_SELECTION"
export const HIDE_FACE2FACE_PACKAGE_SELECTION = "HIDE_FACE2FACE_PACKAGE_SELECTION"

export const FACE2FACE_EDIT_PACKAGE_START ="FACE2FACE_EDIT_PACKAGE_START"
export const FACE2FACE_EDIT_PACKAGE_SUCCESS ="FACE2FACE_EDIT_PACKAGE_SUCCESS"
export const FACE2FACE_EDIT_PACKAGE_FAILURE ="FACE2FACE_EDIT_PACKAGE_FAILURE"

export const DELETED_PACKAGES ="DELETED_PACKAGES"
export const FACE_TO_FACE_DELTE_PACKAGE_FAILURE ="FACE_TO_FACE_DELTE_PACKAGE_FAILURE"
export const FACE_TO_FACE_DELTE_PACKAGE_SUCCESS ="FACE_TO_FACE_DELTE_PACKAGE_SUCCESS"

export const FACE_2FACE_PACKGE_FOR_USER ="FACE_2FACE_PACKGE_FOR_USER"
export const FACE_2FACE_PACKGE_FOR_USER_SUCCESS = "FACE_2FACE_PACKGE_FOR_USER_SUCCESS"
export const FACE_2FACE_PACKGE_FOR_USER_FAILURE ="FACE_2FACE_PACKGE_FOR_USER_FAILURE"

export const FACE_2_FACE_SESSION="FACE_2_FACE_SESSION"
export const FACE_TO_FACE_SESSION_FAILURE="FACE_TO_FACE_SESSION_FAILURE"
export const FACE_TO_FACE_SESSION_SUCCESS="FACE_TO_FACE_SESSION_SUCCESS"

export const FACE_TO_FACE_CALL_HISTORY="FACE_TO_FACE_CALL_HISTORY"
export const FACE_TO_FACE_CALL_HISTORY_SUCCESS="FACE_TO_FACE_CALL_HISTORY_SUCCESS"
export const FACE_TO_FACE_CALL_HISTORY_FAILURE="FACE_TO_FACE_CALL_HISTORY_FAILURE"

export const FACE_2_FACE_SESSION_CREATE ="FACE_2_FACE_SESSION_CREATE"
export const FACE_2_FACE_SESSIONCREATE_SUCCESS ="FACE_2_FACE_SESSIONCREATE_SUCCESS"
export const FACE_2_FACE_SESSION_FAILURE ="FACE_2_FACE_SESSION_FAILURE"

export const FACE_2_FACE_SEND_TIP ="FACE_2_FACE_SEND_TIP"
export const FACE_2_FACE_SEND_TIP_SUCCESS ="FACE_2_FACE_SEND_TIP_SUCCESS"
export const FACE_2_FACE_SEND_TIP_FAILURE ="FACE_2_FACE_SEND_TIP_FAILURE"

export const FETCH_USER_DETAILS_START = 'FETCH_USER_DETAILS_START'
export const FETCH_USER_DETAILS_SUCCESS = 'FETCH_USER_DETAILS_SUCCESS'
export const FETCH_USER_DETAILS_FAILURE = 'FETCH_USER_DETAILS_FAILURE'

export const EDIT_USER_DETAILS = 'EDIT_USER_DETAILS'
export const UPDATE_USER_DETAILS_START = 'UPDATE_USER_DETAILS_START'
export const UPDATE_USER_DETAILS_SUCCESS = 'UPDATE_USER_DETAILS_SUCCESS'
export const UPDATE_USER_DETAILS_FAILURE = 'UPDATE_USER_DETAILS_FAILURE'
export const UPDATE_USER_SECURITY_SETTING_START = 'UPDATE_USER_SECURITY_SETTING_START'
export const UPDATE_USER_SOCIAL_MEDIA_SETTING_START = 'UPDATE_USER_SOCIAL_MEDIA_SETTING_START'

export const UPDATE_USER_NOTIFICATION_SETTING_START = 'UPDATE_USER_NOTIFICATION_SET     TING_START'
export const UPDATE_USER_NOTIFICATION_SETTING_FAILURE = 'UPDATE_USER_NOTIFICATION_SETTING_FAILURE'
export const UPDATE_USER_NOTIFICATION_SETTING_SUCCESS = 'UPDATE_USER_NOTIFICATION_SETTING_SUCCESS'

export const UPDATE_USER_PROFILE_VISIBILITY_SETTING_START = 'UPDATE_USER_PROFILE_VISIBILITY_SETTING_START'

export const UPDATE_USER_COVER_START = 'UPDATE_USER_COVER_START'
export const UPDATE_USER_COVER_SUCCESS = 'UPDATE_USER_COVER_SUCCESS'
export const UPDATE_USER_COVER_FAILURE = 'UPDATE_USER_COVER_FAILURE'

export const UPDATE_USER_PICTURE_START = 'UPDATE_USER_PICTURE_START'
export const UPDATE_USER_PICTURE_SUCCESS = 'UPDATE_USER_PICTURE_SUCCESS'
export const UPDATE_USER_PICTURE_FAILURE = 'UPDATE_USER_PICTURE_FAILURE'

export const EDIT_CHANGE_PASSWORD = 'EDIT_CHANGE_PASSWORD'

export const CHANGE_PASSWORD_START = 'CHANGE_PASSWORD_START'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'

export const DELETE_ACCOUNT_START = 'DELETE_ACCOUNT_START'
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS'
export const DELETE_ACCOUNT_FAILURE = 'DELETE_ACCOUNT_FAILURE'

export const FETCH_PAYMENTS_START = 'FETCH_PAYMENTS_START'
export const FETCH_PAYMENTS_SUCCESS = 'FETCH_PAYMENTS_SUCCESS'
export const FETCH_PAYMENTS_FAILURE = 'FETCH_PAYMENTS_FAILURE'

export const GET_LOGIN_DETAILS = 'GET_LOGIN_DETAILS'

export const LOGIN_START = 'LOGIN_START'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'

export const GOOGLE_SIGNIN_START = 'GOOGLE_SIGNIN_START'
export const GOOGLE_SIGNIN_SUCCESS = 'GOOGLE_SIGNIN_SUCCESS'
export const GOOGLE_SIGNIN_FAILURE = 'GOOGLE_SIGNIN_FAILURE'

export const REGISTER_START = 'REGISTER_START'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILURE = 'REGISTER_FAILURE'

export const GET_REGISTER_DETAILS = 'GET_REGISTER_DETAILS'

export const FORGOT_PASSWORD_START = 'FORGOT_PASSWORD_START'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE'

export const USER_ONLINE_STATUS_CHANGED = 'USER_ONLINE_STATUS_CHANGED'
export const GET_FORGOT_PASSWORD_DETAILS = 'GET_FORGOT_PASSWORD_DETAILS'

// Subscription constants
export const FETCH_SUBSCRIPTION_START = 'FETCH_SUBSCRIPTION_START'
export const FETCH_SUBSCRIPTION_SUCCESS = 'FETCH_SUBSCRIPTION_SUCCESS'
export const FETCH_SUBSCRIPTION_FAILURE = 'FETCH_SUBSCRIPTION_FAILURE'

export const FETCH_MY_ACTIVE_SUBSCRIPTION_START = 'FETCH_MY_ACTIVE_SUBSCRIPTION_START'
export const FETCH_MY_ACTIVE_SUBSCRIPTION_SUCCESS = 'FETCH_MY_ACTIVE_SUBSCRIPTION_SUCCESS'
export const FETCH_MY_ACTIVE_SUBSCRIPTION_FAILURE = 'FETCH_MY_ACTIVE_SUBSCRIPTION_FAILURE'

export const FETCH_ACTIVE_SUBSCRIBERS_START = 'FETCH_ACTIVE_SUBSCRIBERS_START'
export const FETCH_ACTIVE_SUBSCRIBERS_SUCCESS = 'FETCH_ACTIVE_SUBSCRIBERS_SUCCESS'
export const FETCH_ACTIVE_SUBSCRIBERS_FAILURE = 'FETCH_ACTIVE_SUBSCRIBERS_FAILURE'

export const FETCH_MY_ACTION_SUBSCRIPTIONS_START = 'FETCH_MY_ACTIVE_SUBSCRIPTIONS_START'
export const FETCH_MY_ACTION_SUBSCRIPTIONS_SUCCESS = 'FETCH_MY_ACTIVE_SUBSCRIPTIONS_SUCCESS'
export const FETCH_MY_ACTION_SUBSCRIPTIONS_FAILURE = 'FETCH_MY_ACTIVE_SUBSCRIPTIONS_FAILURE'

export const IS_SUBSCRIBED_TO_START = 'IS_SUBSCRIBED_TO_START'
export const IS_SUBSCRIBED_TO_SUCCESS = 'CHECK_IS_SUBCRIBED_TO_USER_SUCCESS'
export const IS_SUBSCRIBED_TO_FAILURE = 'IS_SUBSCRIBED_TO_FAILURE'

export const FETCH_SINGLE_SUBSCRIPTION_START = 'FETCH_SINGLE_SUBSCRIPTION_START'
export const FETCH_SINGLE_SUBSCRIPTION_SUCCESS = 'FETCH_SINGLE_SUBSCRIPTION_SUCCESS'
export const FETCH_SINGLE_SUBSCRIPTION_FAILURE = 'FETCH_SINGLE_SUBSCRIPTION_FAILURE'

export const SUBSCRIPTION_PAYMENT_STRIPE_START = 'SUBSCRIPTION_PAYMENT_STRIPE_START'
export const SUBSCRIPTION_PAYMENT_STRIPE_SUCCESS = 'SUBSCRIPTION_PAYMENT_STRIPE_SUCCESS'
export const SUBSCRIPTION_PAYMENT_STRIPE_FAILURE = 'SUBSCRIPTION_PAYMENT_STRIPE_FAILURE'

export const SUBSCRIPTION_PAYMENT_WALLET_START = 'SUBSCRIPTION_PAYMENT_WALLET_START'
export const SUBSCRIPTION_PAYMENT_WALLET_SUCCESS = 'SUBSCRIPTION_PAYMENT_WALLET_SUCCESS'
export const SUBSCRIPTION_PAYMENT_WALLET_FAILURE = 'SUBSCRIPTION_PAYMENT_WALLET_FAILURE'

export const SUBSCRIPTION_AUTO_RENEWAL_START = 'SUBSCRIPTION_AUTO_RENEWAL_START'
export const SUBSCRIPTION_AUTO_RENEWAL_SUCCESS = 'SUBSCRIPTION_AUTO_RENEWAL_SUCCESS'
export const SUBSCRIPTION_AUTO_RENEWAL_FAILURE = 'SUBSCRIPTION_AUTO_RENEWAL_FAILURE'

export const FETCH_SUBSCRIPTION_PLAN_START = 'FETCH_SUBSCRIPTION_PLAN_START'
export const FETCH_SUBSCRIPTOIN_PLAN_SUCCESS = 'FETCH_SUBSCRIPTION_PLAN_SUCCESS'
export const FETCH_SUBSCRIPTION_PLAN_FAILURE = 'FETCH_SUBSCRIPTION_PLAN_FAILURE'
export const FETCH_PERFORMER_SUBSCRIPTION_PLAN_START = 'FETCH_PERFORMER_SUBSCRIPTION_PLAN_START'
export const FETCH_PERFORMER_SUBSCRIPTION_PLAN_FAILURE = 'FETCH_PERFORMER_SUBSCRIPTION_PLAN_FAILURE'
export const FETCH_PERFORMER_SUBSCRIPTION_PLAN_SUCCESS = ''

export const SUBSCRIBE_TO_PLAN_START = 'SUBSCRIBE_TO_PLAN_START'
export const SUBSCRIBE_TO_PLAN_SUCCESS = 'SUBSCRIBE_TO_PLAN_SUCCESS'
export const SUBSCRIBE_TO_PLAN_FAILURE = 'SUBSCRIBE_TO_PLAN_FAILURE'

export const CANCEL_SUBSCRIPTION_START = 'CANCEL_SUBSCRIPTION_START'
export const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS'
export const CANCEL_SUBSCRIPTION_FAILURE = 'CANCEL_SUBSCRIPTION_FAILURE'

export const UPDATE_DEFAULT_SUBSCRIPTION = 'UPDATE_DEFAULT_SUBSCRIPTION'

export const DELETE_SUBSCRIPTION_PLAN_START = 'DELETE_SUBSCRIPTION_PLAN_START'
export const DELETE_SUBSCRIPTION_PLAN_SUCCESS = 'DELETE_SUBSCRIPTION_PLAN_SUCCESS'
export const DELETE_SUBSCRIPTION_PLAN_FAILURE = 'DELETE_SUBSCRIPTION_PLAN_FAILURE'
// Cards constants

export const FETCH_CARD_DETAILS_START = 'FETCH_CARD_DETAILS_START'
export const FETCH_CARD_DETAILS_SUCCESS = 'FETCH_CARD_DETAILS_SUCCESS'
export const FETCH_CARD_DETAILS_FAILURE = 'FETCH_CARD_DETAILS_FAILURE'

export const DELETE_CARD_START = 'DELETE_CARD_START'
export const DELETE_CARD_SUCCESS = 'DELETE_CARD_SUCCESS'
export const DELETE_CARD_FAILURE = 'DELETE_CARD_FAILURE'

export const SELECT_DEFAULT_CARD_START = 'SELECT_DEFAULT_CARD_START'
export const SELECT_DEFAULT_CARD_SUCCESS = 'SELECT_DEFAULT_CARD_SUCCESS'
export const SELECT_DEFAULT_CARD_FAILURE = 'SELECT_DEFAULT_CARD_FAILURE'

// Bank account

export const ADD_BANK_ACCOUNT_START = 'ADD_BANK_ACCOUNT_START'
export const ADD_BANK_ACCOUNT_SUCCESS = 'ADD_BANK_ACCOUNT_SUCCESS'
export const ADD_BANK_ACCOUNT_FAILURE = 'ADD_BANK_ACCOUNT_FAILURE'

export const GET_BANK_ACCOUNT_START = 'GET_BANK_ACCOUNT_START'
export const GET_BANK_ACCOUNT_SUCCESS = 'GET_BANK_ACCOUNT_SUCCESS'
export const GET_BANK_ACCOUNT_FAILURE = 'GET_BANK_ACCOUNT_FAILURE'

export const DELETE_BANK_ACCOUNT_START = 'DELETE_BANK_ACCOUNT_START'
export const DELETE_BANK_ACCOUNT_SUCCESS = 'DELETE_BANK_ACCOUNT_SUCCESS'
export const DELETE_BANK_ACCOUNT_FAILURE = 'DELETE_BANK_ACCOUNT_FAILURE'

export const ADD_BANK_ACCOUNT_DATA = 'ADD_BANK_ACCOUNT_DATA'

export const FETCH_SINGLE_BANK_ACCOUNT_START = 'FETCH_SINGLE_BANK_ACCOUNT_START'
export const FETCH_SINGLE_BANK_ACCOUNT_SUCCESS = 'FETCH_SINGLE_BANK_ACCOUNT_SUCCESS'
export const FETCH_SINGLE_BANK_ACCOUNT_FAILURE = 'FETCH_SINGLE_BANK_ACCOUNT_FAILURE'

export const MAKE_DEFAULT_BANK_ACCOUNT_START = 'MAKE_DEFAULT_BANK_ACCOUNT_START'
export const MAKE_DEFAULT_BANK_ACCOUNT_SUCCESS = 'MAKE_DEFAULT_BANK_ACCOUNT_SUCCESS'
export const MAKE_DEFAULT_BANK_ACCOUNT_FAILURE = 'MAKE_DEFAULT_BANK_ACCOUNT_FAILURE'

export const GET_KYC_DOCUMENT_START = 'GET_KYC_DOCUMENT_START'
export const GET_KYC_DOCUMENT_SUCCESS = 'GET_KYC_DOCUMENT_SUCCESS'
export const GET_KYC_DOCUMENT_FAILURE = 'GET_KYC_DOCUMENT_FAILURE'

export const ADD_KYC_DOCUMENT_START = 'ADD_KYC_DOCUMENT_START'
export const ADD_KYC_DOCUMENT_SUCCESS = 'ADD_KYC_DOCUMENT_SUCCESS'
export const ADD_KYC_DOCUMENT_FAILURE = 'ADD_KYC_DOCUMENT_FAILURE'

// Wallet constants
export const FETCH_WALLET_DETAILS_START = 'FETCH_WALLET_DETAILS_START'
export const FETCH_WALLET_DETAILS_SUCCESS = 'FETCH_WALLET_DETAILS_SUCCESS'
export const FETCH_WALLET_DETAILS_FAILURE = 'FETCH_WALLET_DETAILS_FAILURE'

export const ADD_MONEY_VIA_CARD_START = 'ADD_MONEY_VIA_CARD_START'
export const ADD_MONEY_VIA_CARD_SUCCESS = 'ADD_MONEY_VIA_CARD_SUCCESS'
export const ADD_MONEY_VIA_CARD_FAILURE = 'ADD_MONEY_VIA_CARD_FAILURE'

export const ADD_MONEY_VIA_CRYPTO_START = 'ADD_MONEY_VIA_CRYPTO_START'
export const ADD_MONEY_VIA_CRYPTO_SUCCESS = 'ADD_MONEY_VIA_CRYPTO_SUCCESS'
export const ADD_MONEY_VIA_CRYPTO_FAILURE = 'ADD_MONEY_VIA_CRYPTO_FAILURE'

// Transaction constants.
export const FETCH_ALL_TRANSACTION_START = 'FETCH_ALL_TRANSACTION_START'
export const FETCH_ALL_TRANSACTION_SUCCESS = 'FETCH_ALL_TRANSACTION_SUCCESS'
export const FETCH_ALL_TRANSACTION_FAILURE = 'FETCH_ALL_TRANSACTION_FAILURE'

export const FETCH_SENT_PAYMENT_TRANSACTION_START = 'FETCH_SENT_PAYMENT_TRANSACTION_START'
export const FETCH_SENT_PAYMENT_TRANSACTION_SUCCESS = 'FETCH_SENT_PAYMENT_TRANSACTION_SUCCESS'
export const FETCH_SENT_PAYMENT_TRANSACTION_FAILURE = 'FETCH_SENT_PAYMENT_TRANSACTION_FAILURE'

export const FETCH_RECEIVED_PAYMENT_TRANSACTION_START = 'FETCH_RECEIVED_PAYMENT_TRANSACTION_START'
export const FETCH_RECEIVED_PAYMENT_TRANSACTION_SUCCESS = 'FETCH_RECEIVED_PAYMENT_TRANSACTION_SUCCESS'
export const FETCH_RECEIVED_PAYMENT_TRANSACTION_FAILURE = 'FETCH_RECEIVED_PAYMENT_TRANSACTION_FAILURE'

export const FETCH_DEPOSIT_TRANSACTION_START = 'FETCH_DEPOSIT_TRANSACTION_START'
export const FETCH_DEPOSIT_TRANSACTION_SUCCESS = 'FETCH_DEPOSIT_TRANSACTION_SUCCESS'
export const FETCH_DEPOSIT_TRANSACTION_FAILURE = 'FETCH_DEPOSIT_TRANSACTION_FAILURE'

export const FETCH_REVERSED_TRANSACTION_START = 'FETCH_REVERSED_TRANSACTION_START'
export const FETCH_REVERSED_TRANSACTION_SUCCESS = 'FETCH_REVERSED_TRANSACTION_SUCCESS'
export const FETCH_REVERSED_TRANSACTION_FAILURE = 'FETCH_REVERSED_TRANSACTION_FAILURE'

// Invoice constants.
export const SAVE_BUSINESS_DETAILS_START = 'SAVE_BUSINESS_DETAILS_START'
export const SAVE_BUSINESS_DETAILS_SUCCESS = 'SAVE_BUSINESS_DETAILS_SUCCESS'
export const SAVE_BUSINESS_DETAILS_FAILURE = 'SAVE_BUSINESS_DETAILS_FAILURE'

export const FETCH_BUSINESS_DETAILS_START = 'FETCH_BUSINESS_DETAILS_START'
export const FETCH_BUSINESS_DETAILS_SUCCESS = 'FETCH_BUSINESS_DETAILS_SUCCESS'
export const FETCH_BUSINESS_DETAILS_FAILURE = 'FETCH_BUSINESS_DETAILS_FAILURE'

// Video store constants
export const FETCH_VIDEO_STORE_ITEMS_START = 'FETCH_VIDEO_STORE_ITEMS_START'
export const FETCH_VIDEO_STORE_ITEMS_SUCCESS = 'FETCH_VIDEO_STORE_ITEMS_SUCCESS'
export const FETCH_VIDEO_STORE_ITEMS_FAILURE = 'FETCH_VIDEO_STORE_ITEMS_FAILURE'

export const FETCH_VIDEO_STORE_SUGGESTIONS_START = 'FETCH_VIDEO_STORE_SUGGESTIONS_START'
export const FETCH_VIDEO_STORE_SUGGESTIONS_SUCCESS = 'FETCH_VIDEO_STORE_SUGGESTIONS_SUCCESS'
export const FETCH_VIDEO_STORE_SUGGESTIONS_FAILURE = 'FETCH_VIDEO_STORE_SUGGESTIONS_FAILURE'

export const CHANGE_VIDEO_STORE_VISIBILITY_START = 'CHANGE_VIDEO_STORE_VISIBILITY_START'
export const CHANGE_VIDEO_STORE_VISIBILITY_SUCCESS = 'CHANGE_VIDEO_STORE_VISIBILITY_SUCCESS'
export const CHANGE_VIDEO_STORE_VISIBILITY_FAILURE = 'CHANGE_VIDEO_STORE_VISIBILITY_FAILURE' 

// Withdraw constants

export const SEND_WITHDRAW_REQUEST_START = 'SEND_WITHDRAW_REQUEST_START'
export const SEND_WITHDRAW_REQUEST_SUCCESS = 'SEND_WITHDRAW_REQUEST_SUCCESS'
export const SEND_WITHDRAW_REQUEST_FAILURE = 'SEND_WITHDRAW_REQUEST_FAILURE'

export const FETCH_WITHDRAWALS_START = 'FETCH_WITHDRAWALS_START'
export const FETCH_WITHDRAWALS_SUCCESS = 'FETCH_WITHDRAWALS_SUCCESS'
export const FETCH_WITHDRAWALS_FAILURE = 'FETCH_WITHDRAWALS_FAILURE'

export const CANCEL_WITHDRAW_REQUEST_START = 'CANCEL_WITHDRAW_REQUEST_START'
export const CANCEL_WITHDRAW_REQUEST_SUCCESS = 'CANCEL_WITHDRAW_REQUEST_SUCCESS'
export const CANCEL_WITHDRAW_REQUEST_FAILURE = 'CANCEL_WITHDRAW_REQUEST_FAILURE'

export const SEARCH_WITHDRAWALS_START = 'SEARCH_WITHDRAWALS_START'
export const SEARCH_WITHDRAWALS_SUCCESS = 'SEARCH_WITHDRAWALS_SUCCESS'
export const SEARCH_WITHDRAWALS_FAILURE = 'SEARCH_WITHDRAWALS_FAILURE'

export const FETCH_SINGLE_WITHDRAWALS_START = 'FETCH_SINGLE_WITHDRAWALS_START'
export const FETCH_SINGLE_WITHDRAWALS_SUCCESS = 'FETCH_SINGLE_WITHDRAWALS_SUCCESS'
export const FETCH_SINGLE_WITHDRAWALS_FAILURE = 'FETCH_SINGLE_WITHDRAWALS_FAILURE'

// Dispute constants

export const SEND_DISPUTE_REQUEST_START = 'SEND_DISPUTE_REQUEST_START'
export const SEND_DISPUTE_REQUEST_SUCCESS = 'SEND_DISPUTE_REQUEST_SUCCESS'
export const SEND_DISPUTE_REQUEST_FAILURE = 'SEND_DISPUTE_REQUEST_FAILURE'

export const FETCH_DISPUTES_START = 'FETCH_DISPUTES_START'
export const FETCH_DISPUTES_SUCCESS = 'FETCH_DISPUTES_SUCCESS'
export const FETCH_DISPUTES_FAILURE = 'FETCH_DISPUTES_FAILURE'

export const FETCH_OPENED_CASE_START = 'FETCH_OPENED_CASE_START'
export const FETCH_OPENED_CASE_SUCCESS = 'FETCH_OPENED_CASE_SUCCESS'
export const FETCH_OPENED_CASE_FAILURE = 'FETCH_OPENED_CASE_FAILURE'

export const FETCH_CLOSED_CASE_START = 'FETCH_CLOSED_CASE_START'
export const FETCH_CLOSED_CASE_SUCCESS = 'FETCH_CLOSED_CASE_SUCCESS'
export const FETCH_CLOSED_CASE_FAILURE = 'FETCH_CLOSED_CASE_FAILURE'

export const GET_SINGLE_DISPUTE_MESSAGES_START = 'GET_SINGLE_DISPUTE_MESSAGES_START'
export const GET_SINGLE_DISPUTE_MESSAGES_SUCCESS = 'GET_SINGLE_DISPUTE_MESSAGES_SUCCESS'
export const GET_SINGLE_DISPUTE_MESSAGES_FAILURE = 'GET_SINGLE_DISPUTE_MESSAGES_FAILURE'

export const SEND_DISPUTE_MESSAGE_START = 'SEND_DISPUTE_MESSAGE_START'
export const SEND_DISPUTE_MESSAGE_SUCCESS = 'SEND_DISPUTE_MESSAGE_SUCCESS'
export const SEND_DISPUTE_MESSAGE_FAILURE = 'SEND_DISPUTE_MESSAGE_FAILURE'

export const CANCEL_DISPUTE_REQUEST_START = 'CANCEL_DISPUTE_REQUEST_START'
export const CANCEL_DISPUTE_REQUEST_SUCCESS = 'CANCEL_DISPUTE_REQUEST_SUCCESS'
export const CANCEL_DISPUTE_REQUEST_FAILURE = 'CANCEL_DISPUTE_REQUEST_FAILURE'

export const FETCH_SINGLE_DISPUTE_START = 'FETCH_SINGLE_DISPUTE_START'
export const FETCH_SINGLE_DISPUTE_SUCCESS = 'FETCH_SINGLE_DISPUTE_SUCCESS'
export const FETCH_SINGLE_DISPUTE_FAILURE = 'FETCH_SINGLE_DISPUTE_FAILURE'

// Email verification
export const EMAIL_VERIFICATION_START = 'EMAIL_VERIFICATION_START'
export const EMAIL_VERIFICATION_RESET = 'EMAIL_VERIFICATION_RESET'
export const EMAIL_VERIFICATION_SUCCESS = 'EMAIL_VERIFICATION_SUCCESS'
export const EMAIL_VERIFICATION_FAILURE = 'EMAIL_VERIFICATION_FAILURE'

export const EMAIL_VERIFICATION_RESEND_START = 'EMAIL_VERIFICATION_RESEND_START'
export const EMAIL_VERIFICATION_RESEND_RESET = 'EMAIL_VERIFICATION_RESEND_RESET'
export const EMAIL_VERIFICATION_RESEND_SUCCESS = 'EMAIL_VERIFICATION_RESEND_SUCCESS'
export const EMAIL_VERIFICATION_RESEND_FAILURE = 'EMAIL_VERIFICATION_RESEND_FAILURE'

// Pages

export const FETCH_SINGLE_PAGE_START = 'FETCH_SINGLE_PAGE_START'
export const FETCH_SINGLE_PAGE_SUCCESS = 'FETCH_SINGLE_PAGE_SUCCESS'
export const FETCH_SINGLE_PAGE_FAILURE = 'FETCH_SINGLE_PAGE_FAILURE'

export const FETCH_SITE_WORKING_CONTENT_START = 'FETCH_SITE_WORKING_CONTENT_START'
export const FETCH_SITE_WORKING_CONTENT_SUCCESS = 'FETCH_SITE_WORKING_CONTENT_SUCCESS'
export const FETCH_SITE_WORKING_CONTENT_FAILURE = 'FETCH_SITE_WORKING_CONTENT_FAILURE'

// Notification on or off

export const NOTIFICATION_STATUS_UPDATE_START = 'NOTIFICATION_STATUS_UPDATE_START'
export const NOTIFICATION_STATUS_UPDATE_SUCCESS = 'NOTIFICATION_STATUS_UPDATE_SUCCESS'
export const NOTIFICATION_STATUS_UPDATE_FAILURE = 'NOTIFICATION_STATUS_UPDATE_FAILURE'

// Error Handling for logout

export const ERROR_LOGOUT_CHECK = 'ERROR_LOGOUT_CHECK'

// Product owner constant

export const SAVE_PRO_OWNER_START = 'SAVE_PRO_OWNER_START'
export const SAVE_PRO_OWNER_SUCCESS = 'SAVE_PRO_OWNER_SUCCESS'
export const SAVE_PRO_OWNER_FAILURE = 'SAVE_PRO_OWNER_FAILURE'

export const FETCH_SINGLE_PRO_OWNER_START = 'FETCH_SINGLE_PRO_OWNER_START'
export const FETCH_SINGLE_PRO_OWNER_SUCCESS = 'FETCH_SINGLE_PRO_OWNER_SUCCESS'
export const FETCH_SINGLE_PRO_OWNER_FAILURE = 'FETCH_SINGLE_PRO_OWNER_FAILURE'

export const SET_VISIBILITY_PRO_OWNER_START = 'SET_VISIBILITY_PRO_OWNER_START'
export const SET_VISIBILITY_PRO_OWNER_SUCCESS = 'SET_VISIBILITY_PRO_OWNER_SUCCESS'
export const SET_VISIBILITY_PRO_OWNER_FAILURE = 'SET_VISIBILITY_PRO_OWNER_FAILURE'

export const UPDATE_AVAILABILITY_PRO_OWNER_START = 'UPDATE_AVAILABILITY_PRO_OWNER_START'
export const UPDATE_AVAILABILITY_PRO_OWNER_SUCCESS = 'UPDATE_AVAILABILITY_PRO_OWNER_SUCCESS'
export const UPDATE_AVAILABILITY_PRO_OWNER_FAILURE = 'UPDATE_AVAILABILITY_PRO_OWNER_FAILURE'

export const FETCH_PRODUCTS_PRO_OWNER_START = 'FETCH_PRODUCTS_PRO_OWNER_START'
export const FETCH_PRODUCTS_PRO_OWNER_SUCCESS = 'FETCH_PRODUCTS_PRO_OWNER_SUCCESS'
export const FETCH_PRODUCTS_PRO_OWNER_FAILURE = 'FETCH_PRODUCTS_PRO_OWNER_FAILURE'

export const FETCH_PRO_CATE_PRO_OWNER_START = 'FETCH_PRO_CATE_PRO_OWNER_START'
export const FETCH_PRO_CATE_PRO_OWNER_SUCCESS = 'FETCH_PRO_CATE_PRO_OWNER_SUCCESS'
export const FETCH_PRO_CATE_PRO_OWNER_FAILURE = 'FETCH_PRO_CATE_PRO_OWNER_FAILURE'

export const FETCH_PRO_SUBCATE_PRO_OWNER_START = 'FETCH_PRO_SUBCATE_PRO_OWNER_START'
export const FETCH_PRO_SUBCATE_PRO_OWNER_SUCCESS = 'FETCH_PRO_SUBCATE_PRO_OWNER_SUCCESS'
export const FETCH_PRO_SUBCATE_PRO_OWNER_FAILURE = 'FETCH_PRO_SUBCATE_PRO_OWNER_FAILURE'

export const PRO_SEARCH_PRO_OWNER_START = 'PRO_SEARCH_PRO_OWNER_START'
export const PRO_SEARCH_PRO_OWNER_SUCCESS = 'PRO_SEARCH_PRO_OWNER_SUCCESS'
export const PRO_SEARCH_PRO_OWNER_FAILURE = 'PRO_SEARCH_PRO_OWNER_FAILURE'

export const FETCH_PRO_IMAGE_PRO_OWNER_START = 'FETCH_PRO_IMAGE_PRO_OWNER_START'
export const FETCH_PRO_IMAGE_PRO_OWNER_SUCCESS = 'FETCH_PRO_IMAGE_PRO_OWNER_SUCCESS'
export const FETCH_PRO_IMAGE_PRO_OWNER_FAILURE = 'FETCH_PRO_IMAGE_PRO_OWNER_FAILURE'

export const SAVE_PRO_IMAGE_PRO_OWNER_START = 'SAVE_PRO_IMAGE_PRO_OWNER_START'
export const SAVE_PRO_IMAGE_PRO_OWNER_SUCCESS = 'SAVE_PRO_IMAGE_PRO_OWNER_SUCCESS'
export const SAVE_PRO_IMAGE_PRO_OWNER_FAILURE = 'SAVE_PRO_IMAGE_PRO_OWNER_FAILURE'

export const DELETE_PRO_IMAGE_PRO_OWNER_START = 'DELETE_PRO_IMAGE_PRO_OWNER_START'
export const DELETE_PRO_IMAGE_PRO_OWNER_SUCCESS = 'DELETE_PRO_IMAGE_PRO_OWNER_SUCCESS'
export const DELETE_PRO_IMAGE_PRO_OWNER_FAILURE = 'DELETE_PRO_IMAGE_PRO_OWNER_FAILURE'

// Post constants

export const SAVE_POST_START = 'SAVE_POST_START'
export const SAVE_POST_SUCCESS = 'SAVE_POST_SUCCESS'
export const SAVE_POST_FAILURE = 'SAVE_POST_FAILURE'

export const FETCH_POSTS_START = 'FETCH_POSTS_START'
export const FETCH_POSTS_SUCCESS = 'FETCH_POSTS_SUCCESS'
export const FETCH_POSTS_FAILURE = 'FETCH_POSTS_FAILURE'
export const UPDATE_USER_POST_LIKE = 'UPDATE_USER_POST_LIKE'
export const UPDATE_USER_POST_COMMENTS = 'USER_POST_COMMENTS'
export const UPDATE_USER_POST_COMMENT_COUNT = 'USER_POST_COMMENT_COUNT'
export const UPDATE_USER_POST_BOOKMARK_STATUS = 'UPDATE_USER_POST_BOOKMARK_STATUS'
export const UPDATE_USER_POST_HAS_STORY_STATUS = 'UPDATE_USER_POST_HAS_STORY_STATUS'
export const SET_USER_POST = 'SET_USER_POST'
export const SET_BOOKMARK_POST = 'SET_BOOKMARK_POST'
export const UPDATE_POST = 'UPDATE_POST';
export const UPDATE_POST_SUCCESS = 'UPDATE_POST_SUCCESS';
export const UPDATE_POST_TRAVELING_LOCATION_START = 'UPDATE_POST_TRAVELING_LOCATION_START';
export const UPDATE_POST_TRAVELING_LOCATION_SUCCESS = 'UPDATE_POST_TRAVELING_LOCATION_SUCCESS';
export const UPDATE_POST_TRAVELING_LOCATION_FAILURE = 'UPDATE_POST_TRAVELING_LOCATION_FAILURE';

export const SET_SINGLE_POST = 'SET_SINGLE_POST'
export const FETCH_SINGLE_POST_START = 'FETCH_SINGLE_POST_START'
export const FETCH_SINGLE_POST_SUCCESS = 'FETCH_SINGLE_POST_SUCCESS'
export const FETCH_SINGLE_POST_FAILURE = 'FETCH_SINGLE_POST_FAILURE'

export const DELETE_POST_START = 'DELETE_POST_START'
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS'
export const DELETE_POST_FAILURE = 'DELETE_POST_FAILURE'

export const CHANGE_POST_STATUS_START = 'CHANGE_POST_STATUS_START'
export const CHANGE_POST_STATUS_SUCCESS = 'CHANGE_POST_STATUS_SUCCESS'
export const CHANGE_POST_STATUS_FAILURE = 'CHANGE_POST_STATUS_FAILURE'

export const GENERATE_POST_PREVIEW_START = 'GENERATE_POST_PREVIEW_START'
export const GENERATE_POST_PREVIEW_SUCCESS = 'GENERATE_POST_PREVIEW_SUCCESS'
export const GENERATE_POST_PREVIEW_FAILURE = 'GENERATE_POST_PREVIEW_FAILURE'

// story constants
export const SAVE_STORY_START = 'SAVE_STORY_START'
export const SAVE_STORY_SUCCESS = 'SAVE_STORY_SUCCESS'
export const SAVE_STORY_FAILURE = 'SAVE_STORY_FAILURE'

export const SAVE_FROM_POST_START = 'SAVE_FROM_POST_START'
export const SAVE_FROM_POST_SUCCESS = 'SAVE_FROM_POST_SUCCESS'
export const SAVE_FROM_POST_FAILURE = 'SAVE_FROM_POST_FAILURE'

export const DELETE_STORY_START = 'DELETE_STORY_START'
export const DELETE_STORY_SUCCESS = 'DELETE_STORY_SUCCESS'
export const DELETE_STORY_FAILURE = 'DELETE_STORY_FAILURE'

export const FETCH_STORY_START = 'FETCH_STORY_START'
export const FETCH_STORY_SUCCESS = 'FETCH_STORY_SUCCESS'
export const FETCH_STORY_FAILURE = 'FETCH_STORY_FAILURE'

// Follow constants

export const FOLLOW_USER_START = 'FOLLOW_USER_START'
export const FOLLOW_USER_SUCCESS = 'FOLLOW_USER_SUCCESS'
export const FOLLOW_USER_FAILURE = 'FOLLOW_USER_FAILURE'

export const UNFOLLOW_USER_START = 'UNFOLLOW_USER_START'
export const UNFOLLOW_USER_SUCCESS = 'UNFOLLOW_USER_SUCCESS'
export const UNFOLLOW_USER_FAILURE = 'UNFOLLOW_USER_FAILURE'

export const FETCH_FOLLOWERS_START = 'FETCH_FOLLOWERS_START'
export const FETCH_FOLLOWERS_SUCCESS = 'FETCH_FOLLOWERS_SUCCESS'
export const FETCH_FOLLOWERS_FAILURE = 'FETCH_FOLLOWERS_FAILURE'

export const FETCH_ACTIVE_FOLLOWERS_START = 'FETCH_ACTIVE_FOLLOWERS_START'
export const FETCH_ACTIVE_FOLLOWERS_SUCCESS = 'FETCH_ACTIVE_FOLLOWERS_SUCCESS'
export const FETCH_ACTIVE_FOLLOWERS_FAILURE = 'FETCH_ACTIVE_FOLLOWERS_FAILURE'

export const FETCH_EXPIRED_FOLLOWERS_START = 'FETCH_EXPIRED_FOLLOWERS_START'
export const FETCH_EXPIRED_FOLLOWERS_SUCCESS = 'FETCH_EXPIRED_FOLLOWERS_SUCCESS'
export const FETCH_EXPIRED_FOLLOWERS_FAILURE = 'FETCH_EXPIRED_FOLLOWERS_FAILURE'

export const FETCH_FOLLOWING_START = 'FETCH_FOLLOWING_START'
export const FETCH_FOLLOWING_SUCCESS = 'FETCH_FOLLOWING_SUCCESS'
export const FETCH_FOLLOWING_FAILURE = 'FETCH_FOLLOWING_FAILURE'

export const FETCH_ACTIVE_FOLLOWING_START = 'FETCH_ACTIVE_FOLLOWING_START'
export const FETCH_ACTIVE_FOLLOWING_SUCCESS = 'FETCH_ACTIVE_FOLLOWING_SUCCESS'
export const FETCH_ACTIVE_FOLLOWING_FAILURE = 'FETCH_ACTIVE_FOLLOWING_FAILURE'

export const FETCH_EXPIRED_FOLLOWING_START = 'FETCH_EXPIRED_FOLLOWING_START'
export const FETCH_EXPIRED_FOLLOWING_SUCCESS = 'FETCH_EXPIRED_FOLLOWING_SUCCESS'
export const FETCH_EXPIRED_FOLLOWING_FAILURE = 'FETCH_EXPIRED_FOLLOWING_FAILURE'

// Document verification

export const FETCH_VERI_DOCUMENT_START = 'FETCH_VERI_DOCUMENT_START'
export const FETCH_VERI_DOCUMENT_SUCCESS = 'FETCH_VERI_DOCUMENT_SUCCESS'
export const FETCH_VERI_DOCUMENT_FAILURE = 'FETCH_VERI_DOCUMENT_FAILURE'

export const SAVE_VERI_DOC_START = 'SAVE_VERI_DOC_START'
export const SAVE_VERI_DOC_SUCCESS = 'SAVE_VERI_DOC_SUCCESS'
export const SAVE_VERI_DOC_FAILURE = 'SAVE_VERI_DOC_FAILURE'

export const DEL_VERI_DOC_START = 'DEL_VERI_DOC_START'
export const DEL_VERI_DOC_SUCCESS = 'DEL_VERI_DOC_SUCCESS'
export const DEL_VERI_DOC_FAILURE = 'DEL_VERI_DOC_FAILURE'

export const VERI_STATUS_CHECK_START = 'VERI_STATUS_CHECK_START'
export const VERI_STATUS_CHECK_SUCCESS = 'VERI_STATUS_CHECK_SUCCESS'
export const VERI_STATUS_CHECK_FAILURE = 'VERI_STATUS_CHECK_FAILURE'

// Comments constant

export const FETCH_COMMENTS_START = 'FETCH_COMMENTS_START'
export const FETCH_COMMENTS_SUCCESS = 'FETCH_COMMENTS_SUCCESS'
export const FETCH_COMMENTS_FAILURE = 'FETCH_COMMENTS_FAILURE'

export const SAVE_COMMENT_START = 'SAVE_COMMENT_START'
export const SAVE_COMMENT_SUCCESS = 'SAVE_COMMENT_SUCCESS'
export const SAVE_COMMENT_FAILURE = 'SAVE_COMMENT_FAILURE'

export const DELETE_COMMENT_START = 'DELETE_COMMENT_START'
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS'
export const DELETE_COMMENT_FAILURE = 'DELETE_COMMENT_FAILURE'

// Fav constant

export const FETCH_FAV_START = 'FETCH_FAV_START'
export const FETCH_FAV_SUCCESS = 'FETCH_FAV_SUCCESS'
export const FETCH_FAV_FAILURE = 'FETCH_FAV_FAILURE'

export const SAVE_FAV_START = 'SAVE_FAV_START'
export const SAVE_FAV_SUCCESS = 'SAVE_FAV_SUCCESS'
export const SAVE_FAV_FAILURE = 'SAVE_FAV_FAILURE'

export const DELETE_FAV_START = 'DELETE_FAV_START'
export const DELETE_FAV_SUCCESS = 'DELETE_FAV_SUCCESS'
export const DELETE_FAV_FAILURE = 'DELETE_FAV_FAILURE'

// Bookmark Management constant

export const FETCH_BOOKMARKS_START = 'FETCH_BOOKMARKS_START'
export const FETCH_BOOKMARKS_SUCCESS = 'FETCH_BOOKMARKS_SUCCESS'
export const FETCH_BOOKMARKS_FAILURE = 'FETCH_BOOKMARKS_FAILURE'

export const FETCH_BOOKMARKS_PHOTO_START = 'FETCH_BOOKMARKS_PHOTO_START'
export const FETCH_BOOKMARKS_PHOTO_SUCCESS = 'FETCH_BOOKMARKS_PHOTO_SUCCESS'
export const FETCH_BOOKMARKS_PHOTO_FAILURE = 'FETCH_BOOKMARKS_PHOTO_FAILURE'

export const FETCH_BOOKMARKS_VIDEO_START = 'FETCH_BOOKMARKS_VIDEO_START'
export const FETCH_BOOKMARKS_VIDEO_SUCCESS = 'FETCH_BOOKMARKS_VIDEO_SUCCESS'
export const FETCH_BOOKMARKS_VIDEO_FAILURE = 'FETCH_BOOKMARKS_VIDEO_FAILURE'

export const SAVE_BOOKMARK_START = 'SAVE_BOOKMARK_START'
export const SAVE_BOOKMARK_SUCCESS = 'SAVE_BOOKMARK_SUCCESS'
export const SAVE_BOOKMARK_FAILURE = 'SAVE_BOOKMARK_FAILURE'

export const UPDATE_BOOKMARK_POST_LIKES = 'UPDATE_BOOKMARK_POST_LIKES'

export const DELETE_BOOKMARK_START = 'DELETE_BOOKMARK_START'
export const DELETE_BOOKMARK_SUCCESS = 'DELETE_BOOKMARK_SUCCESS'
export const DELETE_BOOKMARK_FAILURE = 'DELETE_BOOKMARK_FAILURE'

// Send Tip constant

export const SEND_TIP_BY_STRIPE_START = 'SEND_TIP_BY_STRIPE_START'
export const SEND_TIP_BY_STRIPE_SUCCESS = 'SEND_TIP_BY_STRIPE_SUCCESS'
export const SEND_TIP_BY_STRIPE_FAILURE = 'SEND_TIP_BY_STRIPE_FAILURE'

export const SEND_TIP_BY_WALLET_START = 'SEND_TIP_BY_WALLET_START'
export const SEND_TIP_BY_WALLET_SUCCESS = 'SEND_TIP_BY_WALLET_SUCCESS'
export const SEND_TIP_BY_WALLET_FAILURE = 'SEND_TIP_BY_WALLET_FAILURE'

export const SEND_STREAMING_TIP_BY_WALLET_START = 'SEND_STREAMING_TIP_BY_WALLET_START'
export const SEND_STREAMING_TIP_BY_WALLET_SUCCESS = 'SEND_STREAMING_TIP_BY_WALLET_SUCCESS'
export const SEND_STREAMING_TIP_BY_WALLET_FAILURE = 'SEND_STREAMING_TIP_BY_WALLET_FAILURE'

export const CLOSE_TIP_MODAL = 'CLOSE_TIP_MODAL'
export const TOGGLE_TIP_MODAL = 'TOGGLE_TIP_MODAL'

export const OPEN_STREAMING_TIP_MODAL = 'OPEN_STREAMING_TIP_MODAL'
export const CLOSE_STREAMING_TIP_MODAL = 'CLOSE_STREAMING_TIP_MODAL'
export const TOGGLE_STREAMING_TIP_MODAL = 'TOGGLE_STREAMING_TIP_MODAL'

export const SET_HOME_POST = 'SET_HOME_POST'
export const FETCH_HOME_POSTS_START = 'FETCH_HOME_POSTS_START'
export const FETCH_HOME_POSTS_SUCCESS = 'FETCH_HOME_POSTS_SUCCESS'
export const FETCH_HOME_POSTS_FAILURE = 'FETCH_HOME_POSTS_FAILURE'

export const SEARCH_USER_START = 'SEARCH_USER_START'
export const SEARCH_USER_SUCCESS = 'SEARCH_USER_SUCCESS'
export const SEARCH_USER_FAILURE = 'SEARCH_USER_FAILURE'

export const FETCH_OTHERS_SINGLE_POST_START = 'FETCH_OTHERS_SINGLE_POST_START'
export const FETCH_OTHERS_SINGLE_POST_SUCCESS = 'FETCH_OTHERS_SINGLE_POST_SUCCESS'
export const FETCH_OTHERS_SINGLE_POST_FAILURE = 'FETCH_OTHERS_SINGLE_POST_FAILURE'
export const UPDATE_OTHERS_USER_POST_LIKE = 'UPDATE_OTHERS_USER_POST_LIKE'
export const UPDATE_OTHER_USER_POST_COMMENTS_COUNT = 'UPDATE_OTHER_USER_POST_COMMENTS_COUNT'
export const UPDATE_OTHER_USER_POST_COMMENTS = 'UPDATE_OTHER_USER_POST_COMMENTS'
export const UPDATE_OTHER_USER_POST_BOOKMARK_STATUS = 'UPDATE_OTHER_USER_POST_BOOKMARK_STATUS'

export const FETCH_POST_SUGGESTION_START = 'FETCH_POST_SUGGESTION_START'
export const FETCH_POST_SUGGESTION_SUCCESS = 'FETCH_POST_SUGGESTION_SUCCESS'
export const FETCH_POST_SUGGESTION_FAILURE = 'FETCH_POST_SUGGESTION_FAILURE'

export const POST_PAYMENT_STRIPE_START = 'POST_PAYMENT_STRIPE_START'
export const POST_PAYMENT_STRIPE_SUCCESS = 'POST_PAYMENT_STRIPE_SUCCESS'
export const POST_PAYMENT_STRIPE_FAILURE = 'POST_PAYMENT_STRIPE_FAILURE'

export const POST_PAYMENT_WALLET_START = 'POST_PAYMENT_WALLET_START'
export const POST_PAYMENT_WALLET_SUCCESS = 'POST_PAYMENT_WALLET_SUCCESS'
export const POST_PAYMENT_WALLET_FAILURE = 'POST_PAYMENT_WALLET_FAILURE'

export const FETCH_LISTS_DETAILS_START = 'FETCH_LISTS_DETAILS_START'
export const FETCH_LISTS_DETAILS_SUCCESS = 'FETCH_LISTS_DETAILS_SUCCESS'
export const FETCH_LISTS_DETAILS_FAILURE = 'FETCH_LISTS_DETAILS_FAILURE'

export const UPDATE_POST_LIKES = 'UPDATE_POST_LIKES'
export const UPDATE_POST_COMMENTS = 'UPDATE_POST_COMMENTS'
export const INCREMENT_POST_TIPS_COUNT = 'INCREMENT_POST_TIPS_COUNT'
export const UPDATE_POST_COMMENTS_COUNT = 'UPDATE_POST_COMMENTS_COUNT'
export const UPDATE_POST_BOOKMARK_STATUS = 'UPDATE_POST_BOOKMARK_STATUS'
export const UPDATE_POST_HAS_STORY_STATUS = 'UPDATE_POST_HAS_STORY_STATUS'
export const UPDATE_POST_ACCESS_STATUS = 'UPDATE_POST_ACCESS_STATUS'

export const FETCH_SINGLE_USER_CONTENT_START = 'FETCH_SINGLE_USER_CONTENT_START'
export const FETCH_SINGLE_USER_PROFILE_START = 'FETCH_SINGLE_USER_PROFILE_START'
export const FETCH_SINGLE_USER_PROFILE_SUCCESS = 'FETCH_SINGLE_USER_PROFILE_SUCCESS'
export const FETCH_SINGLE_USER_PROFILE_FAILURE = 'FETCH_SINGLE_USER_PROFILE_FAILURE'
export const FETCH_SINGLE_USER_PUBLIC_PROFILE_START = 'FETCH_SINGLE_USER_PUBLIC_PROFILE_START'
export const FETCH_SINGLE_USER_PROFILE_RESET = 'FETCH_SINGLE_USER_PROFILE_RESET'

export const SET_OTHER_USER_SINGLE_POST = 'SET_OTHER_USER_SINGLE_POST'

export const FETCH_SINGLE_USER_POSTS_START = 'FETCH_SINGLE_USER_POSTS_START'
export const FETCH_SINGLE_USER_POSTS_SUCCESS = 'FETCH_SINGLE_USER_POSTS_SUCCESS'
export const FETCH_SINGLE_USER_POSTS_FAILURE = 'FETCH_SINGLE_USER_POSTS_FAILURE'
export const FETCH_SINGLE_USER_PUBLIC_POSTS_START = 'FETCH_SINGLE_USER_PUBLIC_POSTS_START'

export const UPDATE_SINGLE_POST_LIKES = 'UPDATE_SINGLE_POST_LIKES'
export const UPDATE_SINGLE_POST_COMMENTS = 'UPDATE_SINGLE_POST_COMMENTS'
export const INCREMENT_SINGLE_POST_TIPS_COUNT = 'INCREMENT_SINGLE_POST_TIPS_COUNT'
export const UPDATE_SINGLE_POST_COMMENTS_COUNT = 'UPDATE_SINGLE_POST_COMMENTS_COUNT'
export const UPDATE_SINGLE_POST_BOOKMARK_STATUS = 'UPDATE_SINGLE_POST_BOOKMARK_STATUS'
export const UPDATE_SINGLE_POST_HAS_STORY_STATUS = 'UPDATE_SINGLE_POST_HAS_STORY_STATUS'

export const FETCH_SEARCH_USER_START = 'FETCH_SEARCH_USER_START'
export const FETCH_SEARCH_USER_SUCCESS = 'FETCH_SEARCH_USER_SUCCESS'
export const FETCH_SEARCH_USER_ERROR = 'FETCH_SEARCH_USER_ERROR'

export const SAVE_POST_LIKE_START = 'SAVE_POST_LIKE_START'
export const SAVE_POST_LIKE_SUCCESS = 'SAVE_POST_LIKE_SUCCESS'
export const SAVE_POST_LIKE_FAILURE = 'SAVE_POST_LIKE_FAILURE'

export const FETCH_POST_LIKED_START = 'FETCH_POST_LIKED_START'
export const FETCH_POST_LIKED_SUCCESS = 'FETCH_POST_LIKED_SUCCESS'
export const FETCH_POST_LIKED_FAILURE = 'FETCH_POST_LIKED_FAILURE'

export const SET_USER_CHATROOMS = 'SET_USER_CHATROOMS'
export const APPEND_MESSAGE = 'APPEND_MESSAGE'
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE'
export const REPLACE_MESSAGE = 'REPLACE_MESSAGE'

export const SET_CHAT_FILTERS = 'SET_CHAT_FILTERS'
export const SET_UNREAD_MESSAGE_COUNT = 'SET_UNREAD_MESSAGE_COUNT'
export const SET_CHATROOMS_USER_ONLINE_STATUS = 'SET_CHATROOMS_USER_ONLINE_STATUS'
export const SET_ACTIVE_CHATROOM_USER_ONLINE_STATUS = 'SET_ACTIVE_CHATROOM_USER_ONLINE_STATUS'
export const FETCH_UNREAD_MESSAGE_AND_NOTIFICATION_COUNT = 'FETCH_UNREAD_MESSAGE_AND_NOTIFICATION_COUNT'

export const SET_ACTIVE_CONVERSATION = 'SET_ACTIVE_CONVERSATION'
export const SET_ACTIVE_CONVERSATION_LOADING = 'SET_ACTIVE_CONVERSATION_LOADING'
export const SET_ACTIVE_CONVERSATION_IF_CURRENT = 'SET_ACTIVE_CONVERSATION_IF_CURRENT'

export const SEND_MESSAGE_START = 'SEND_MESSAGE_START'
export const SEND_MESSAGE_RESET = 'SEND_MESSAGE_RESET'
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS'
export const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE'
export const SEND_MESSAGE_SET_INPUT_DATA = 'SEND_MESSAGE_SET_INPUT_DATA'

export const NEW_CONVERSATION_START = 'NEW_CONVERSATION_START'
export const NEW_CONVERSATION_SUCCESS = 'NEW_CONVERSATION_SUCCESS'
export const NEW_CONVERSATION_FAILURE = 'NEW_CONVERSATION_FAILURE'

export const DELETE_CONVERSATION_START = 'DELETE_CONVERSATION_START'
export const DELETE_CONVERSATION_SUCCESS = 'DELETE_CONVERSATION_SUCCESS'
export const DELETE_CONVERSATION_FAILURE = 'DELETE_CONVERSATION_FAILURE'

export const FETCH_CHAT_MESSAGE_START = 'FETCH_CHAT_MESSAGE_START'
export const FETCH_CHAT_MESSAGE_SUCCESS = 'FETCH_CHAT_MESSAGE_SUCCESS'
export const FETCH_CHAT_MESSAGE_FAILURE = 'FETCH_CHAT_MESSAGE_FAILURE'

export const FETCH_USER_CHATROOMS_START = 'FETCH_USER_CHATROOMS_START'
export const FETCH_USER_CHATROOMS_SUCCESS = 'FETCH_USER_CHATROOMS_SUCCESS'
export const FETCH_USER_CHATROOMS_FAILURE = 'FETCH_USER_CHATROOMS_FAILURE'

export const START_CONVERSATION_START = 'START_CONVERSATION_START'
export const START_CONVERSATION_SUCCESS = 'START_CONVERSATION_SUCCESS'
export const START_CONVERSATION_FAILURE = 'START_CONVERSATION_FAILURE'

export const UNLOCK_MESSAGE_PAYMENT_START = 'UNLOCK_MESSAGE_PAYMENT_START'
export const UNLOCK_MESSAGE_PAYMENT_SUCCESS = 'UNLOCK_MESSAGE_PAYMENT_SUCCESS'
export const UNLOCK_MESSAGE_PAYMENT_FAILURE = 'UNLOCK_MESSAGE_PAYMENT_FAILURE'

export const GET_BULK_SEND_USERS_START = 'GET_BULK_SEND_USERS_START'
export const GET_BULK_SEND_USERS_SUCCESS = 'GET_BULK_SEND_USERS_SUCCESS'
export const GET_BULK_SEND_USERS_FAILURE = 'GET_BULK_SEND_USERS_FAILURE'
export const GET_BULK_SEND_USERS_TOGGLE_SELECTED = 'GET_BULK_SEND_USERS_TOGGLE_SELECTED'

export const GET_BULK_SEND_METADATA_START = 'GET_BULK_SEND_METADATA_START'
export const GET_BULK_SEND_METADATA_SUCCESS = 'GET_BULK_SEND_METADATA_SUCCESS'
export const GET_BULK_SEND_METADATA_FAILURE = 'GET_BULK_SEND_METADATA_FAILURE'

export const FETCH_NOTIFICATIONS_START = 'FETCH_NOTIFICATIONS_START'
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS'
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE'
export const SET_FETCH_NOTIFICATION_PAGINATION = 'SET_FETCH_NOTIFICATION_PAGINATION'
export const RESET_NOTIFICATION_DATA = 'RESET_NOTIFICATION_DATA'
export const FETCH_NOTIFICATION_BELL_COUNT_START = 'FETCH_NOTIFICATION_BELL_COUNT_START'
export const FETCH_NOTIFICATION_BELL_COUNT_SUCCESS = 'FETCH_NOTIFICATION_BELL_COUNT_SUCCESS'

export const PPV_PAYMENT_STRIPE_START = 'PPV_PAYMENT_STRIPE_START'
export const PPV_PAYMENT_STRIPE_SUCCESS = 'PPV_PAYMENT_STRIPE_SUCCESS'
export const PPV_PAYMENT_STRIPE_FAILURE = 'PPV_PAYMENT_STRIPE_FAILURE'

export const PPV_PAYMENT_WALLET_START = 'PPV_PAYMENT_WALLET_START'
export const PPV_PAYMENT_WALLET_SUCCESS = 'PPV_PAYMENT_WALLET_SUCCESS'
export const PPV_PAYMENT_WALLET_FAILURE = 'PPV_PAYMENT_WALLET_FAILURE'

export const SAVE_BLOCK_USER_START = 'SAVE_BLOCK_USER_START'
export const SAVE_BLOCK_USER_SUCCESS = 'SAVE_BLOCK_USER_SUCCESS'
export const SAVE_BLOCK_USER_FAILURE = 'SAVE_BLOCK_USER_FAILURE'

export const FETCH_BLOCK_USERS_START = 'FETCH_BLOCK_USERS_START'
export const FETCH_BLOCK_USERS_SUCCESS = 'FETCH_BLOCK_USERS_SUCCESS'
export const FETCH_BLOCK_USERS_FAILURE = 'FETCH_BLOCK_USERS_FAILURE'

export const SAVE_REPORT_POST_START = 'SAVE_REPORT_POST_START'
export const SAVE_REPORT_POST_SUCCESS = 'SAVE_REPORT_POST_SUCCESS'
export const SAVE_REPORT_POST_FAILURE = 'SAVE_REPORT_POST_FAILURE'

export const SAVE_REPORT_USER_START = 'SAVE_REPORT_USER_START'
export const SAVE_REPORT_USER_SUCCESS = 'SAVE_REPORT_USER_SUCCESS'
export const SAVE_REPORT_USER_FAILURE = 'SAVE_REPORT_USER_FAILURE'

export const FETCH_REPORT_POSTS_START = 'FETCH_REPORT_POSTS_START'
export const FETCH_REPORT_POSTS_SUCCESS = 'FETCH_REPORT_POSTS_SUCCESS'
export const FETCH_REPORT_POSTS_FAILURE = 'FETCH_REPORT_POSTS_FAILURE'

export const SUBSCRIPTION_PAYMENT_PAYPAL_START = 'SUBSCRIPTION_PAYMENT_PAYPAL_START'
export const SUBSCRIPTION_PAYMENT_PAYPAL_SUCCESS = 'SUBSCRIPTION_PAYMENT_PAYPAL_SUCCESS'
export const SUBSCRIPTION_PAYMENT_PAYPAL_FAILURE = 'SUBSCRIPTION_PAYMENT_PAYPAL_FAILURE'

export const PPV_PAYMENT_PAYPAL_START = 'PPV_PAYMENT_PAYPAL_START'
export const PPV_PAYMENT_PAYPAL_SUCCESS = 'PPV_PAYMENT_PAYPAL_SUCCESS'
export const PPV_PAYMENT_PAYPAL_FAILURE = 'PPV_PAYMENT_PAYPAL_FAILURE'

export const SEND_TIP_BY_PAYPAL_START = 'SEND_TIP_BY_PAYPAL_START'
export const SEND_TIP_BY_PAYPAL_SUCCESS = 'SEND_TIP_BY_PAYPAL_SUCCESS'
export const SEND_TIP_BY_PAYPAL_FAILURE = 'SEND_TIP_BY_PAYPAL_FAILURE'

export const USER_VERIFY_BADGE_STATUS_START = 'USER_VERIFY_BADGE_STATUS_START'
export const USER_VERIFY_BADGE_STATUS_SUCCESS = 'USER_VERIFY_BADGE_STATUS_SUCCESS'
export const USER_VERIFY_BADGE_STATUS_FAILURE = 'USER_VERIFY_BADGE_STATUS_FAILURE'

export const RESET_PASSWORD_START = 'RESET_PASSWORD_START'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'

export const USERNAME_VALIDATION_START = 'USERNAME_VALIDATION_START'
export const USERNAME_VALIDATION_SUCCESS = 'USERNAME_VALIDATION_SUCCESS'
export const USERNAME_VALIDATION_FAILURE = 'USERNAME_VALIDATION_FAILURE'

export const SEARCH_USER_POST_START = 'SEARCH_USER_POST_START'
export const SEARCH_USER_POST_SUCCESS = 'SEARCH_USER_POST_SUCCESS'
export const SEARCH_USER_POST_FAILURE = 'SEARCH_USER_POST_FAILURE'

export const HIDE_USER_UNVERIFIED_MODAL = 'HIDE_USER_UNVERIFIED_MODAL'
export const SHOW_USER_UNVERIFIED_MODAL = 'SHOW_USER_UNVERIFIED_MODAL'
export const TOGGLE_USER_UNVERIFIED_MODAL = 'TOGGLE_USER_UNVERIFIED_MODAL'

export const HIDE_PERFORMER_PROFILE_PICTURE_MISSING_MODAL = 'HIDE_PERFORMER_PROFILE_PICTURE_MISSING_MODAL'
export const SHOW_PERFORMER_PROFILE_PICTURE_MISSING_MODAL = 'SHOW_PERFORMER_PROFILE_PICTURE_MISSING_MODAL'
export const TOGGLE_PERFORMER_PROFILE_PICTURE_MISSING_MODAL = 'TOGGLE_PERFORMER_PROFILE_PICTURE_MISSING_MODAL'

export const HIDE_CARD_ADDRESS_MISMATCH_MODAL = 'HIDE_CARD_ADDRESS_MISMATCH_MODAL'
export const SHOW_CARD_ADDRESS_MISMATCH_MODAL = 'SHOW_CARD_ADDRESS_MISMATCH_MODAL'
export const TOGGLE_CARD_ADDRESS_MISMATCH_MODAL = 'TOGGLE_CARD_ADDRESS_MISMATCH_MODAL'

export const HIDE_CARD_MANUAL_REVIEW_REQUIRED_MODAL = 'HIDE_CARD_MANUAL_REVIEW_REQUIRED_MODAL'
export const SHOW_CARD_MANUAL_REVIEW_REQUIRED_MODAL = 'SHOW_CARD_MANUAL_REVIEW_REQUIRED_MODAL'
export const TOGGLE_CARD_MANUAL_REVIEW_REQUIRED_MODAL = 'TOGGLE_CARD_MANUAL_REVIEW_REQUIRED_MODAL'

export const HIDE_USER_OTP_MODAL = 'HIDE_USER_OTP_MODAL'
export const SHOW_USER_OTP_MODAL = 'SHOW_USER_OTP_MODAL'
export const TOGGLE_USER_OTP_MODAL = 'TOGGLE_USER_OTP_MODAL'

export const HIDE_LIVE_STREAMING_PAYMENT_DIALOG = 'HIDE_LIVE_STREAMING_PAYMENT_DIALOG'
export const SHOW_LIVE_STREAMING_PAYMENT_DIALOG = 'SHOW_LIVE_STREAMING_PAYMENT_DIALOG'

export const FETCH_CHATROOMS = 'FETCH_CHATROOMS'
export const SET_CHAT_FOLLOWERS = 'SET_CHAT_FOLLOWERS'

export const FETCH_CARD_START = 'FETCH_CARD_START'
export const FETCH_CARD_SUCCESS = 'FETCH_CARD_SUCCESS'
export const FETCH_CARD_FAILURE = 'FETCH_CARD_FAILURE'

export const ADD_CARD_START = 'ADD_CARD_START'
export const ADD_CARD_SUCCESS = 'ADD_CARD_SUCCESS'
export const ADD_CARD_FAILURE = 'ADD_CARD_FAILURE'

export const GET_CARD_START = 'GET_CARD_START'
export const GET_CARD_SUCCESS = 'GET_CARD_SUCESS'
export const GET_CARD_FAILURE = 'GET_CARD_FAILURE'

export const UPDATE_CARD_START = 'UPDATE_CARD_START'
export const UPDATE_CARD_SUCCESS = 'UPDATE_CARD_SUCCESS'
export const UPDATE_CARD_FAILURE = 'UPDATE_CARD_FAILURE'

export const VERIFY_CARD_START = 'VERIFY_CARD_START'
export const VERIFY_CARD_SUCCESS = 'VERIFY_CARD_SUCCESS'
export const VERIFY_CARD_FAILURE = 'VERIFY_CARD_FAILURE'

export const DOCUMENT_UPLOAD_FOR_CARD_VERIFICATION_START = 'DOCUMENT_UPLOAD_FOR_CARD_VERIFICATION_START'
export const DOCUMENT_UPLOAD_FOR_CARD_VERIFICATION_RESET = 'DOCUMENT_UPLOAD_FOR_CARD_VERIFICATION_RESET'

export const FETCH_WALLET_HISTORY_START = 'FETCH_WALLET_HISTORY_START'
export const FETCH_WALLET_HISTORY_SUCCESS = 'FETCH_WALLET_HISTORY_SUCCESS'
export const FETCH_WALLET_HISTORY_FAILURE = 'FETCH_WALLET_HISTORY_FAILURE'

// Fetch income wallet history
export const FETCH_INCOME_WALLET_HISTORY_START = 'FETCH_INCOME_WALLET_HISTORY_START'

// Fetch earnings summary
export const FETCH_EARNING_SUMMARY_START = 'FETCH_EARNING_SUMMARY_SUMMARY_START'
export const FETCH_EARNING_SUMMARY_SUCCESS = 'FETCH_EARNING_SUMMARY_SUCCESS'
export const FETCH_EARNING_SUMMARY_FAILURE = 'FETCH_EARNING_SUMMARY_FAILURE'

//transfer to bank

export const TRANSFER_TO_BANK_START = 'TRANSFER_TO_BANK_START'
export const TRANSFER_TO_BANK_SUCCESS = 'TRANSFER_TO_BANK_SUCCESS'
export const TRANSFER_TO_BANK_FAILED = 'TRANSFER_TO_BANK_FAILED'
export const MASSPAY_LOAD_START = 'MASSPAY_LOAD_START'

//toggleBanckAccountModal

export const TOGGLE_BANK_ACCOUNT_MODAL = 'TOGGLE_BANK_ACCOUNT_MODAL'
export const SET_MODAL_COMPONENT_TYPE = 'SET_MODAL_COMPONENT_TYPE'

//get user profile

export const FETCH_CURRENT_USER_START = 'FETCH_CURRENT_USER_START'
export const FETCH_CURRENT_USER_FAILED = 'FETCH_CURRENT_USER_FAILED'
export const FETCH_CURRENT_USER_SUCCESS = 'FETCH_CURRENT_USER_SUCCESS'

//toggle post payment modal

export const OPEN_UNLOCK_CONTENT_MODAL = 'OPEN_UNLOCK_CONTENT_MODAL'
export const CLOSE_UNLOCK_CONTENT_MODAL = 'CLOSE_UNLOCK_CONTENT_MODAL'

// Subscription Bundle

export const SET_SUBSCRIPTION_BUNDLE_START = 'SET_SUBSCRIPTION_BUNDLE_START'
export const SET_SUBSCRIPTION_BUNDLE_SUCCESS = 'SET_SUBSCRIPTION_BUNDLE_SUCCESS'
export const SET_SUBSCRIPTION_BUNDLE_FAILED = 'SET_SUBSCRIPTION_BUNDLE_FAILED'

//set subcscription price

export const SET_SUBSCRIPTION_PRICE_START = 'SET_SUBSCRIPTION_PRICE_START'
export const SET_SUBSCRIPTION_PRICE_SUCCESS = 'SET_SUBSCRIPTION_PRICE_SUCCESS'
export const SET_SUBSCRIPTION_PRICE_FAILED = 'SET_SUBSCRIPTION_PRICE_FAILED'

// fetch user devices
export const FETCH_USER_DEVICES_START = 'FETCH_USER_DEVICES_START'
export const FETCH_USER_DEVICES_SUCCESS = 'FETCH_USER_DEVICES_SUCCESS'
export const FETCH_USER_DEVICES_FAILURE = 'FETCH_USER_DEVICES_FAILURE'

// Unsubscribe
export const USER_UNSUBSCRIBE_START = 'USER_UNSUBSCRIBE_START'
export const USER_UNSUBSCRIBE_SUCCESS = 'USER_UNSUBSCRIBE_SUCCESS'
export const USER_UNSUBSCRIBE_FAILED = 'USER_UNSUBSCRIBE_FAILED'

//subscription bundles

export const BUNDLE_MODAL_OPEN = 'BUNDLE_MODAL_OPEN'
export const BUNDLE_MODAL_CLOSE = 'BUNDLE_MODAL_CLOSE'

// search
export const APPLY_FILTER = 'APPLY_FILTER'
export const SET_SEARCH_KEY = 'SET_SEARCH_KEY'
export const CLEAR_SEARCH_KEY = 'CLEAR_SEARCH_KEY'
export const SET_FILTER_COUNT = 'SET_FILTER_COUNT'
export const SET_FILTER_VALUES = 'SET_FILTER_VALUES'

//Verify reset email
export const VERIFY_RESET_EMAIL_START = 'VERIFY_RESET_EMAIL_START'
export const VERIFY_RESET_EMAIL_SUCCESS = 'VERIFY_RESET_EMAIL_SUCCESS'
export const VERIFY_RESET_EMAIL_FAILURE = 'VERIFY_RESET_EMAIL_FAILURE'
export const CLEAR_RESET_EMAIL = 'CLEAR_RESET_EMAIL'

export const CLEAR_INVALID_EMAIL = 'CLEAR_INVALID_EMAIL'

// Verify reset token
export const VERIFY_RESET_TOKEN_START = 'VERIFY_RESET_TOKEN_START'
export const VERIFY_RESET_TOKEN_SUCCESS = 'VERIFY_RESET_TOKEN_SUCCESS'
export const VERIFY_RESET_TOKEN_FAILURE = 'VERIFY_RESET_TOKEN_FAILURE'

// Site stats
export const FETCH_SITE_STAT_START = 'FETCH_SITE_STAT_START'
export const FETCH_SITE_STAT_SUCCESS = 'FETCH_SITE_STAT_SUCCESS'
export const FETCH_SITE_STAT_FAILED = 'FETCH_SITE_STAT_FAILED'

// help and support content
export const FETCH_HELP_AND_SUPPORT_CONTENT_START = 'FETCH_HELP_AND_SUPPORT_CONTENT_START'
export const FETCH_HELP_AND_SUPPORT_CONTENT_SUCCESS = 'FETCH_HELP_AND_SUPPORT_CONTENT_SUCCESS'
export const FETCH_HELP_AND_SUPPORT_CONTENT_FAILURE = 'FETCH_HELP_AND_SUPPORT_CONTENT_FAILURE'

//Countries
export const FETCH_COUNTRIES_START = 'FETCH_COUNTRIES_START'
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS'
export const FETCH_COUNTRIES_FAILURE = 'FETCH_COUNTRIES_FAILURE'

// User Configurations
export const FETCH_USER_CONFIGURATIONS_START = 'FETCH_USER_CONFIGURATIONS_START'
export const FETCH_USER_CONFIGURATIONS_SUCCESS = 'FETCH_USER_CONFIGURATIONS_SUCCESS'
export const FETCH_USER_CONFIGURATIONS_FAILURE = 'FETCH_USER_CONFIGURATIONS_FAILURE'
export const SEARCH_CITIES_START = 'SEARCH_CITIES_START'
export const SEARCH_CITIES_SUCCESS = 'SEARCH_CITIES_SUCCESS'
export const SEARCH_CITIES_FAILURE = 'SEARCH_CITIES_FAILURE'
export const SEARCH_STATES_START = 'SEARCH_STATES_START'
export const SEARCH_STATES_SUCCESS = 'SEARCH_STATES_SUCCESS'
export const SEARCH_STATES_FAILURE = 'SEARCH_STATES_FAILURE'
export const SEARCH_LOCATIONS_START = 'SEARCH_LOCATIONS_START'
export const SEARCH_LOCATIONS_SUCCESS = 'SEARCH_LOCATIONS_SUCCESS'
export const SEARCH_LOCATIONS_FAILURE = 'SEARCH_LOCATIONS_FAILURE'

// Payout
export const INITIATE_PAYOUT_START = 'INITIATE_PAYOUT_START'
export const INITIATE_PAYOUT_SUCCESS = 'INITIATE_PAYOUT_SUCCESS'
export const INITIATE_PAYOUT_FAILURE = 'INITIATE_PAYOUT_FAILURE'
export const UPDATE_PAYOUT_MAX_AMOUNT = 'UPDATE_PAYOUT_MAX_AMOUNT'
export const INITIATE_PAYOUT_TABLE  = 'INITIATE_PAYOUT_TABLE'
export const FETCH_PAYOUT_SERVICES_START = 'FETCH_PAYOUT_SERVICES_START'
export const FETCH_PAYOUT_SERVICES_SUCCESS = 'FETCH_PAYOUT_SERVICES_SUCCESS'
export const FETCH_PAYOUT_SERVICES_FAILURE = 'FETCH_PAYOUT_SERVICES_FAILURE'
export const UPDATE_PAYOUT = 'UPDATE_PAYOUT'
export const REFRESH_UNIQUEID = 'REFRESH_UNIQUEID'
export const UPDATE_PAYOUT_ATTRIBUTE_VALUE = 'UPDATE_PAYOUT_ATTRIBUTE_VALUE'
export const UPDATE_PAYOUT_DUPLICATE_ATTRIBUTE_VALUE = 'UPDATE_PAYOUT_DUPLICATE_ATTRIBUTE_VALUE'
export const FETCH_PAYOUT_ATTRIBUTES_START = 'FETCH_PAYOUT_ATTRIBUTES_START'
export const FETCH_PAYOUT_ATTRIBUTES_SUCCESS = 'FETCH_PAYOUT_ATTRIBUTES_SUCCESS'
export const FETCH_PAYOUT_ATTRIBUTES_FAILURE = 'FETCH_PAYOUT_ATTRIBUTES_FAILURE'
export const FETCH_PAYOUT_DRAFT_START = 'FETCH_PAYOUT_DRAFT_START'
export const FETCH_PAYOUT_DRAFT_SUCCESS = 'FETCH_PAYOUT_DRAFT_SUCCESS'
export const FETCH_PAYOUT_DRAFT_FAILURE = 'FETC_PAYOUT_DRAFT_FAILURE'
export const CONFIRM_PAYOUT_DRAFT_START = 'CONFIRM_PAYOUT_DRAFT_START'
export const CONFIRM_PAYOUT_DRAFT_SUCCESS = 'CONFIRM_PAYOUT_DRAFT_SUCCESS'
export const CONFIRM_PAYOUT_DRAFT_FAILURE = 'CONFIRM_PAYOUT_DRAFT_FAILURE'
//Modals

export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const TOGGLE_MODAL = 'TOGGLE_MODAL'

// Stories
export const FETCH_HOME_STORIES_START = 'FETCH_HOME_STORIES_START'
export const FETCH_HOME_STORIES_SUCCESS = 'FETCH_HOME_STORIES_SUCCESS'
export const FETCH_HOME_STORIES_FAILURE = 'FETCH_HOME_STORIES_FAILURE'

export const FETCH_PROFILE_STORIES_START = 'FETCH_PROFILE_STORIES_START'
export const FETCH_PROFILE_STORIES_SUCCESS = 'FETCH_PROFILE_STORIES_SUCCESS'
export const FETCH_PROFILE_STORIES_FAILURE = 'FETCH_PROFILE_STORIES_FAILURE'
export const CLEAR_PROFILE_STORIES_START = 'CLEAR_PROFILE_STORIES_START'

/**
 * Live Streaming
 */
// Live Streaming Channels
export const FETCH_LIVE_STREAMING_CHANNELS_START = 'FETCH_LIVE_STREAMING_CHANNELS_START'
export const FETCH_LIVE_STREAMING_CHANNELS_SUCCESS = 'FETCH_LIVE_STREAMING_CHANNELS_SUCCESS'
export const FETCH_LIVE_STREAMING_CHANNELS_FAILURE = 'FETCH_LIVE_STREAMING_CHANNELS_FAILURE'

// Fetch Live Performers
export const FETCH_LIVE_PERFORMERS_START = 'FETCH_LIVE_PERFORMERS_START'
export const FETCH_LIVE_PERFORMERS_SUCCESS = 'FETCH_LIVE_PERFORMERS_SUCCESS'
export const FETCH_LIVE_PERFORMERS_FAILURE = 'FETCH_LIVE_PERFORMERS_FAILURE'

// Live Streaming Summary
export const FETCH_LIVE_STREAMING_SUMMARY_START = 'FETCH_LIVE_STREAMING_SUMMARY_START'
export const FETCH_LIVE_STREAMING_SUMMARY_SUCCESS = 'FETCH_LIVE_STREAMING_SUMMARY_SUCCESS'
export const FETCH_LIVE_STREAMING_SUMMARY_FAILURE = 'FETCH_LIVE_STREAMING_SUMMARY_FAILURE'

// Go Live
export const GO_LIVE_START = 'GO_LIVE_START'
export const GO_LIVE_SUCCESS = 'GO_LIVE_SUCCESS'
export const GO_LIVE_FAILURE = 'GO_LIVE_FAILURE'

// Streamer channel
export const SET_STREAMER_CHANNEL = 'SET_STREAMER_CHANNEL'
export const SET_STREAMER_CHANNEL_LOADING = 'SET_STREAMER_CHANNEL_LOADING'
export const FETCH_STREAMER_CHANNEL_START = 'FETCH_STREAMER_CHANNEL_START'
export const FETCH_STREAMER_CHANNEL_FAILURE = 'FETCH_STREAMER_CHANNEL_FAILURE'
export const FETCH_STREAMER_CHANNEL_SUCCESS = 'FETCH_STREAMER_CHANNEL_SUCCESS'

// Streaming channel
export const SET_STREAMING_CHANNEL_IS_PAID = 'SET_STREAMING_CHANNEL_IS_PAID'
export const SET_STREAMING_CHANNEL_MESSAGES = 'SET_STREAMING_CHANNEL_MESSAGES'
export const FETCH_LIVE_STREAMING_CHANNEL_START = 'FETCH_LIVE_STREAMING_CHANNEL_START'
export const FETCH_LIVE_STREAMING_CHANNEL_FAILURE = 'FETCH_LIVE_STREAMING_CHANNEL_FAILURE'
export const FETCH_LIVE_STREAMING_CHANNEL_SUCCESS = 'FETCH_LIVE_STREAMING_CHANNEL_SUCCESS'

// Live Streaming messaging
export const SET_LIVE_STREAMING_CHANNEL_MESSAGES = 'SET_LIVE_STREAMING_CHANNEL_MESSAGES'
export const APPEND_LIVE_STREAMING_CHANNEL_MESSAGE = 'APPEND_LIVE_STREAMING_CHANNEL_MESSAGE'

// Live Streaming channel payment
export const LIVE_STREAMING_CHANNEL_PAYMENT_START = 'LIVE_STREAMING_CHANNEL_PAYMENT_START'
export const LIVE_STREAMING_CHANNEL_PAYMENT_FAILURE = 'LIVE_STREAMING_CHANNEL_PAYMENT_FAILURE'
export const LIVE_STREAMING_CHANNEL_PAYMENT_SUCCESS = 'LIVE_STREAMING_CHANNEL_PAYMENT_SUCCESS'

export const ADD_LIVE_STREAMING_TIP_PAYMENT = 'ADD_LIVE_STREAMING_TIP_PAYMENT'
export const REMOVE_LIVE_STREAMING_TIP_PAYMENT = 'REMOVE_LIVE_STREAMING_TIP_PAYMENT'

// withdrawal completion
export const MASSPAY_WITHDRAW_SUCCESS = 'MASSPAY_WITHDRAW_SUCCESS'
export const MASSPAY_WITHDRAW_FAILED = 'MASSPAY_WITHDRAW_FAILED'
export const MASSPAY_WITHDRAW_CLEAR = 'MASSPAY_WITHDRAW_CLEAR'

// Theme change

export const TOGGLE_DARK_MODE = 'TOGGLE_DARK_MODE'
export const SET_INITIAL_THEME_MODE = 'SET_INITIAL_THEME_MODE'

export const SET_THEME_MODE = 'SET_THEME_MODE'

// Setting Subscription Free

export const SET_SUBSCRIPTION_FREE_START = 'SET_SUBSCRIPTION_FREE_START'
export const SET_SUBSCRIPTION_FREE_SUCCESS = 'SET_SUBSCRIPTION_FREE_SUCCESS'
export const SET_SUBSCRIPTION_FREE_FAILED = 'SET_SUBSCRIPTION_FREE_FAILED'
export const TOGGLE_SUBSCRIPTION_FREE = 'TOGGLE_SUBSCRIPTION_FREE'

// update follow/ unfollow status

export const UPDATE_FOLLOW_STATUS = 'UPDATE_FOLLOW_STATUS'
// verify email

export const VERIFY_EMAIL_START = 'VERIFY_EMAIL_START'
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS'
export const VERIFY_EMAIL_FAILED = 'VERIFY_EMAIL_FAILED'
export const CLEAR_VERIFY_EMAIL = 'CLEAR_VERIFY_EMAIL'

//verify username

export const VERIFY_USERNAME_START = 'VERIFY_USERNAME_START'
export const VERIFY_USERNAME_SUCCESS = 'VERIFY_USERNAME_SUCCESS'
export const VERIFY_USERNAME_FAILED = 'VERIFY_USERNAME_FAILED'
export const CLEAR_VERIFY_USERNAME = 'CLEAR_VERIFY_USERNAME'

//verify name

export const VERIFY_NAME_START = 'VERIFY_NAME_START'
export const VERIFY_NAME_SUCCESS = 'VERIFY_NAME_SUCCESS'
export const VERIFY_NAME_FAILED = 'VERIFY_NAME_FAILED'
export const CLEAR_VERIFY_NAME = 'CLEAR_VERIFY_NAME'

// clear updateCard details

export const CLEAR_UPDATE_CARD_DETAILS = 'CLEAR_UPDATE_CARD_DETAILS'

// Fetch edit profile Data

export const FETCH_EDIT_PROFILE_START = 'FETCH_EDIT_PROFILE_START'
export const FETCH_EDIT_PROFILE_SUC = 'FETCH_EDIT_PROFILE_SUC'
export const FETCH_EDIT_PROFILE_FAILED = 'FETCH_EDIT_PROFILE_FAILED'

//story read unread status
export const UPDATE_STORY_DATA_STATUS_START = 'UPDATE_STORY_DATA_STATUS_START'
export const UPDATE_STORY_DATA_STATUS_SUCCESS = 'UPDATE_STORY_DATA_STATUS_SUCCESS'
export const UPDATE_STORY_DATA_STATUS_FAILED = 'UPDATE_STORY_DATA_STATUS_FAILED'

////user withdrawal amount is less than the fee 
export const MASSPAY_WITHDRAW_AMOUNT_IS_LESS = 'MASSPAY_WITHDRAW_AMOUNT_IS_LESS'
/// download withdrawal confirm invoice
export const WITHDRAWAL_CONFIRM_DOWNLOAD_START = 'WITHDRAWAL_CONFIRM_DOWNLOAD_START'
export const WITHDRAWAL_CONFIRM_DOWNLOAD_END = 'WITHDRAWAL_CONFIRM_DOWNLOAD_END'
export const UPDATE_EMAIL_START = 'UPDATE_EMAIL_START'
export const UPDATE_EMAIL_END = 'UPDATE_EMAIL_END'
/// reverted user withdrawal 
export const FETCH_REVERSED_USER_WITHDRAWAL_START = 'FETCH_REVERSED_USER_WITHDRAWAL_START'
export const FETCH_REVERSED_USER_WITHDRAWAL_SUCCESS = 'FETCH_REVERSED_USER_WITHDRAWAL_SUCCESS'
export const FETCH_REVERSED_USER_WITHDRAWAL_FAILURE = 'FETCH_REVERSED_USER_WITHDRAWAL_FAILURE'

export const HIDE_ERROR_COMPONENT = 'HIDE_ERROR_COMPONENT'
export const SHOW_ERROR_COMPONENT = 'SHOW_ERROR_COMPONENT'

// fetch f2f performer
export const FETCH_ALL_F2F_PERFORMERS_START = 'FETCH_ALL_F2F_PERFORMERS_START'
export const FETCH_ALL_F2F_PERFORMERS_SUCCESS = 'FETCH_ALL_F2F_PERFORMERS_SUCCESS'
export const FETCH_ALL_F2F_PERFORMERS_FAILURE = 'FETCH_ALL_F2F_PERFORMERS_FAILURE'


// Action types for uploading a user showcase
export const UPLOAD_USER_SHOWCASE_START = 'UPLOAD_USER_SHOWCASE_START'; 
export const UPLOAD_USER_SHOWCASE_SUCCESS = 'UPLOAD_USER_SHOWCASE_SUCCESS'; 
export const UPLOAD_USER_SHOWCASE_FAILED = 'UPLOAD_USER_SHOWCASE_FAILED'; 

// Action types for fetching user showcase
export const FETCH_USER_SHOWCASE_START = 'FETCH_USER_SHOWCASE_START'; 
export const FETCH_USER_SHOWCASE_SUCCESS = 'FETCH_USER_SHOWCASE_SUCCESS'; 
export const FETCH_USER_SHOWCASE_FAILED = 'FETCH_USER_SHOWCASE_FAILED'; 
// Action types for fetching user showcase byID
export const FETCH_USER_SHOWCASE_START_ID = 'FETCH_USER_SHOWCASE_START_ID'; 
export const FETCH_USER_SHOWCASE_SUCCESS_ID = 'FETCH_USER_SHOWCASE_SUCCESS_ID'; 
export const FETCH_USER_SHOWCASE_FAILED_ID = 'FETCH_USER_SHOWCASE_FAILED_ID'; 

// Action types for deleting a user showcase
export const DELETE_USER_SHOWCASE_START = 'DELETE_USER_SHOWCASE_START'; 
export const DELETE_USER_SHOWCASE_SUCCESS = 'DELETE_USER_SHOWCASE_SUCCESS'; 
export const DELETE_USER_SHOWCASE_FAILED = 'DELETE_USER_SHOWCASE_FAILED'; 

// Action types for deleting all user showcases
export const DELETE_ALL_USER_SHOWCASE_START = 'DELETE_ALL_USER_SHOWCASE_START'; 
export const DELETE_ALL_USER_SHOWCASE_SUCCESS = 'DELETE_ALL_USER_SHOWCASE_SUCCESS'; 
export const DELETE_ALL_USER_SHOWCASE_FAILED = 'DELETE_ALL_USER_SHOWCASE_FAILED'; 

//// Action types for visibility a user showcase
export const UPDATE_SHOWCASE_VISIBILITY = 'UPDATE_SHOWCASE_VISIBILITY'; 
export const UPDATE_SHOWCASE_VISIBILITY_FAILED='UPDATE_SHOWCASE_VISIBILITY_FAILED';
export const UPDATE_SHOWCASE_VISIBILITY_SUCCESS='UPDATE_SHOWCASE_VISIBILITY_SUCCESS';

//// Action types for request visibility a user showcase

export const REQUEST_VISIBILITY_SHOWCASE='REQUEST_VISIBILITY_SHOWCASE';
export const REQUEST_VISIBILITY_SHOWCASE_SUCCESS='REQUEST_VISIBILITY_SHOWCASE_SUCCESS';
export const REQUEST_VISIBILITY_SHOWCASE_FAILED='REQUEST_VISIBILITY_SHOWCASE_FAILED'

//// Action types for approved visibility a user showcase

export const APPROVED_VISIBILITY_SHOWCASE='APPROVED_VISIBILITY_SHOWCASE';
export const APPROVED_VISIBILITY_SHOWCASE_SUCCESS='APPROVED_VISIBILITY_SHOWCASE_SUCCESS';
export const APPROVED_VISIBILITY_SHOWCASE_FAILED='APPROVED_VISIBILITY_SHOWCASE_FAILED'

//// Action types for decline visibility a user showcase

export const DECLINE_VISIBILITY_SHOWCASE='DECLINE_VISIBILITY_SHOWCASE';
export const DECLINE_VISIBILITY_SHOWCASE_SUCCESS='DECLINE_VISIBILITY_SHOWCASE_SUCCESS';
export const DECLINE_VISIBILITY_SHOWCASE_FAILED='DECLINE_VISIBILITY_SHOWCASE_FAILED';

export const ACCEPT_POST_COLLABORATION='ACCEPT_POST_COLLABORATION';
export const ACCEPT_POST_COLLABORATION_SUCCESS='ACCEPT_POST_COLLABORATION_SUCCESS';
export const ACCEPT_POST_COLLABORATION_FAILED='ACCEPT_POST_COLLABORATION_FAILED';
export const DECLINE_POST_COLLABORATION='DECLINE_POST_COLLABORATION';
export const DECLINE_POST_COLLABORATION_SUCCESS='DECLINE_POST_COLLABORATION_SUCCESS';
export const DECLINE_POST_COLLABORATION_FAILED='DECLINE_POST_COLLABORATION_FAILED';

// Action types for tracking links
export const FETCH_TRACKING_LINKS_START = 'FETCH_TRACKING_LINKS_START';
export const FETCH_TRACKING_LINKS_SUCCESS = 'FETCH_TRACKING_LINKS_SUCCESS';
export const FETCH_TRACKING_LINKS_FAILED = 'FETCH_TRACKING_LINKS_FAILED';

export const CREATE_TRACKING_LINK_START = 'CREATE_TRACKING_LINK_START';
export const CREATE_TRACKING_LINK_SUCCESS = 'CREATE_TRACKING_LINK_SUCCESS';
export const CREATE_TRACKING_LINK_FAILED = 'CREATE_TRACKING_LINK_FAILED';

export const UPDATE_TRACKING_LINK_START = 'UPDATE_TRACKING_LINK_START';
export const UPDATE_TRACKING_LINK_SUCCESS = 'UPDATE_TRACKING_LINK_SUCCESS';
export const UPDATE_TRACKING_LINK_FAILED = 'UPDATE_TRACKING_LINK_FAILED';
export const DELETE_TRACKING_LINK_START = 'DELETE_TRACKING_LINK_START';
export const DELETE_TRACKING_LINK_SUCCESS = 'DELETE_TRACKING_LINK_SUCCESS';
export const DELETE_TRACKING_LINK_FAILED = 'DELETE_TRACKING_LINK_FAILED';

export const TRACK_VIEW_TRACKING_LINK_START = 'TRACK_VIEW_TRACKING_LINK_START';
export const TRACK_VIEW_TRACKING_LINK_SUCCESS = 'TRACK_VIEW_TRACKING_LINK_SUCCESS';
export const TRACK_VIEW_TRACKING_LINK_FAILED = 'TRACK_VIEW_TRACKING_LINK_FAILED';

//Action type to get the transaction history
export const GET_TRANSACTION_HISTORY_START = 'GET_TRANSACTION_HISTORY_START';
export const GET_TRANSACTION_HISTORY_SUCCESS = 'GET_TRANSACTION_HISTORY_SUCCESS';
export const GET_TRANSACTION_HISTORY_FAILED = 'GET_TRANSACTION_HISTORY_FAILED';

// Action types for creat Ads
export const CREATE_AD_CAMPAIGN_START = 'CREATE_AD_CAMPAIGN_START'; 
export const CREATE_AD_CAMPAIGN_SUCCESS = 'CREATE_AD_CAMPAIGN_SUCCESS'; 
export const CREATE_AD_CAMPAIGN_FAILED = 'CREATE_AD_CAMPAIGN_FAILED'; 

// fetch user Ads
export const FETCH_USER_AD_START = 'FETCH_USER_AD_START'; 
export const FETCH_USER_AD_SUCCESS = 'FETCH_USER_AD_SUCCESS'; 
export const FETCH_USER_AD_FAILED = 'FETCH_USER_AD_FAILED'; 

// fetch user Ads by ID
export const FETCH_USER_AD_START_BY_ID = 'FETCH_USER_AD_START_BY_ID'; 
export const FETCH_USER_AD_SUCCESS_BY_ID = 'FETCH_USER_AD_SUCCESS_BY_ID'; 
export const FETCH_USER_AD_FAILED_BY_ID = 'FETCH_USER_AD_FAILED_BY_ID'; 

//fetch recommended AD
export const FETCH_RECOMMENDED_AD_FOR_USER_START = 'FETCH_RECOMMENDED_AD_FOR_USER_START'; 
export const FETCH_RECOMMENDED_AD_FOR_USER_SUCCESS = 'FETCH_RECOMMENDED_AD_FOR_USER_SUCCESS'; 
export const FETCH_RECOMMENDED_AD_FOR_USER_FAILED = 'FETCH_RECOMMENDED_AD_FOR_USER_FAILED'; 

//publish AD
export const PUBLISH_USER_AD_BY_ID_START = 'PUBLISH_USER_AD_BY_ID_START'; 
export const PUBLISH_USER_AD_BY_ID_SUCCESS = 'PUBLISH_USER_AD_BY_ID_SUCCESS'; 
export const PUBLISH_USER_AD_BY_ID_FAILED = 'PUBLISH_USER_AD_BY_ID_FAILED';

//delete AD by ID
export const DELETE_USER_AD_BY_ID_START = 'DELETE_USER_AD_BY_ID_START'; 
export const DELETE_USER_AD_BY_ID_SUCCESS = 'DELETE_USER_AD_BY_ID_SUCCESS'; 
export const DELETE_USER_AD_BY_ID_FAILED = 'DELETE_USER_AD_BY_ID_FAILED';

//fetch referral pending payments
export const FETCH_PENDING_REFERRAL_PAYMENTS_START = 'FETCH_PENDING_REFERRAL_PAYMENTS_START'; 
export const FETCH_PENDING_REFERRAL_PAYMENTS_SUCCESS = 'FETCH_PENDING_REFERRAL_PAYMENTS_SUCCESS'; 
export const FETCH_PENDING_REFERRAL_PAYMENTS_FAILED = 'FETCH_PENDING_REFERRAL_PAYMENTS_FAILED';

// fetch referral payments except PENDING
export const FETCH_REFERRAL_PAYMENTS_HISTORY_START = 'FETCH_REFERRAL_PAYMENTS_HISTORY_START'; 
export const FETCH_REFERRAL_PAYMENTS_HISTORY_SUCCESS = 'FETCH_REFERRAL_PAYMENTS_HISTORY_SUCCESS'; 
export const FETCH_REFERRAL_PAYMENTS_HISTORY_FAILED = 'FETCH_REFERRAL_PAYMENTS_HISTORY_FAILED';

// fetch referred users
export const FETCH_REFERRED_USERS_START = 'FETCH_REFERRED_USERS_START'; 
export const FETCH_REFERRED_USERS_SUCCESS = 'FETCH_REFERRED_USERS_SUCCESS'; 
export const FETCH_REFERRED_USERS_FAILED = 'FETCH_REFERRED_USERS_FAILED';

// initiate referral withdrawal
export const REFERRAL_WITHDRAWAL_START = 'REFERRAL_WITHDRAWAL_START'; 
export const REFERRAL_WITHDRAWAL_SUCCESS = 'REFERRAL_WITHDRAWAL_SUCCESS'; 
export const REFERRAL_WITHDRAWAL_FAILED = 'REFERRAL_WITHDRAWAL_FAILED';
